import React, { FC, ReactNode, useEffect } from 'react';
import AriaModal from 'react-aria-modal';

export const ModalMobile: FC<{
  ariaTitle: string;
  closeModal: () => void;
  isOpen: boolean;
  mainContent: ReactNode;
  stickyHeader?: {
    height?: string;
    node: ReactNode;
  };
}> = ({ ariaTitle, stickyHeader, mainContent, closeModal }) => {
  useEffect(() => {
    const { pageYOffset } = window || {};
    return () => {
      if (pageYOffset) {
        window.scrollTo(0, pageYOffset);
      }
    };
  });

  return (
    <>
      <AriaModal
        dialogStyle={{
          backgroundColor: '#fff',
          border: '1px solid rgb(204, 204, 204)',
          borderRadius: '5px',
          height: '100%',
          overflow: 'hidden',
          padding: '0',
          width: '100%',
        }}
        onExit={closeModal}
        scrollDisabled
        titleText={ariaTitle}
        underlayClickExits
        underlayColor="rgb(0, 0, 0, 0.8)"
        underlayStyle={{
          padding: '10px',
          zIndex: 1000002,
        }}
        verticallyCenter
      >
        <div className="container">
          <div className="sticky-header">{stickyHeader.node}</div>
          <div className="main-content">{mainContent}</div>
        </div>
      </AriaModal>

      <style jsx>{`
        .container {
          overflow: hidden;
          width: 100%;
          height: 100%;
          max-width: calc(100vw - 15px);
          max-height: calc(100vh - 15px);
          display: flex;
          flex-direction: column;
        }

        .sticky-header {
          width: 100%;
          ${stickyHeader.height ? `height: ${stickyHeader.height}` : ''};
        }

        .main-content {
          flex: 1;
          overflow-y: scroll;
          overflow-x: hidden;
          -webkit-overflow-scrolling: touch;
        }
      `}</style>
    </>
  );
};
